/**
 * @namespace Teaserkarussell
 * @aka KINDERNETZ.Teaserkarussell
 *
 */
KINDERNETZ.Teaserkarussell = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'teaserkarusell';
  var DATA_KEY = 'kindernetz.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy="teasercarousel"]'
  };

  var Default = {
    xsItems: 1
  };

  var DefaultType = {
    xsItems: '(number|boolean|undefined)',
    smItems: '(number|boolean|undefined)',
    mdItems: '(number|boolean|undefined)',
    lgItems: '(number|boolean|undefined)',
    xlItems: '(number|boolean|undefined)'
  };


  /**
   * ------------------------------------------------------------------------
   * Private Helpers
   * ------------------------------------------------------------------------
   */

  $.fn.visible = function(partial) {

    var $t            = $(this),
      $w            = $(window),
      viewTop       = $w.scrollTop(),
      viewBottom    = viewTop + $w.height(),
      _top          = $t.offset().top,
      _bottom       = _top + $t.height(),
      compareTop    = partial === true ? _bottom : _top,
      compareBottom = partial === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop));

  };

  $.fn.setToplinePositionForEventTeaser = function() {
    var self = this;

    $(self).find('.teaser-event').each(function() {
      if ($(this).closest('[class$="-12"]').length > 0) {
        var $headline = $(this).find('[itemprop="headline"]');
        var $topline = $(this).find('.topline');

        if ($headline.length > 0 && $topline.length > 0) {
          $topline.css({'position' : 'absolute',  'bottom': $headline.outerHeight() + 'px'})
        }
      }
    });
  };


  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Teaserkarussell = function () {

    function Teaserkarussell(element, config) {
      var self = this;

      COMMON.Utils._classCallCheck(self, Teaserkarussell);

      self.element = element;

      var $element = $(self.element);

      KINDERNETZ.Utils.destroyOwl($element);

      self.config = self._getConfig(config);

      var owlConfig = {
        autoWidth: false,
        nav: true,
        dots: true,
        loop: false,
        navSpeed: 214,
        margin: 20,
        responsiveClass: true
      };

      var $item = $element.children('[class*=col-]').first();
      if (1 === $item.length) {
        var classList = $item.attr('class').split(/\s+/);

        $.each(classList, function (index, item) {
          var classParts = item.split('-');
          self.config[classParts[1] + 'Items'] = Math.max(1, Math.min(12, Math.round(12 / parseInt(classParts[2]))));

          $element.addClass(classParts[1] + 'Items-' + self.config[classParts[1] + 'Items']);
        });
      }

      if(1 === self.config.smItems && 'undefined' === typeof Cookies.get('KINDERNETZPSO')){
        owlConfig = $.extend({}, owlConfig, {
          autoplay: true,
          autoplayHoverPause: true
        });

        owlConfig.loop = true;
        owlConfig.margin = 0;
      }

      var responsive = {};
      var maxItems = $element.children().length;

      if (false === self.config.xsItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.xsItems) {
        var numItems = self.config.xsItems;
        responsive['0'] = {
          items: numItems <= maxItems ? numItems : maxItems,
          slideBy: 1,
          //autoWidth: 1 !== self.config.smItems && !$element.hasClass('teaser-crew'),
          nav: true,
          //margin: 1 !== self.config.smItems ? 16 : 0,
          margin: 1 !== self.config.smItems && $element.hasClass('teaser-crew') ? 5 : 20,
          dots: 1 === self.config.smItems,
          loop: 1 === self.config.smItems
        };

        responsive['720'] = {
          items: numItems <= maxItems ? numItems : maxItems,
          slideBy: 1,
          nav: true,
          dots: true
        }
      }

      if (false === self.config.smItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.smItems) {
        numItems = self.config.smItems;
        responsive['720'] = {
          items: numItems <= maxItems ? numItems : maxItems,
          slideBy: 1
        }
      }

      if (false === self.config.smItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.smItems) {
        numItems = self.config.smItems;
        responsive['800'] = {
            items: numItems <= maxItems ? numItems : maxItems,
            slideBy: 1
          }
      }

      if (false === self.config.mdItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.mdItems) {
        numItems = self.config.mdItems;
        responsive['970'] = {
            items: numItems <= maxItems ? numItems : maxItems,
            slideBy: 1
          }
      }

      if (false === self.config.lgItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.lgItems) {
        numItems = self.config.lgItems;
        responsive['1170'] = {
            items: numItems <= maxItems ? numItems : maxItems,
            slideBy: 1
          }
      }

      if (false === self.config.xlItems) {
        $element.trigger('destroy.owl.carousel')
      } else if ('number' === typeof self.config.xlItems) {
        numItems = self.config.xlItems;
        responsive['1920'] = {
            items: numItems <= maxItems ? numItems : maxItems,
            slideBy: 1
          }
      }

      if (0 !== responsive.length) {
        owlConfig.responsive = responsive;
      }

      $element.on('initialized.owl.carousel', function(event) {
        $(this).setToplinePositionForEventTeaser();

        KINDERNETZ.Utils.updateLazyLoad();
      });

      $element.on('resized.owl.carousel', function(event) {
        $(this).setToplinePositionForEventTeaser();
      });

      $element.addClass('owl-carousel');
      $element.owlCarousel(owlConfig);

      $(document).on('pjax:beforeReplace', function (event) {
        var $owl = $element;
        if (0 === $owl.length)
          return;

        $owl.removeClass('owl-carousel owl-loaded');
        $owl.find('.owl-nav').remove();
        $owl.find('.owl-dots').remove();
        $owl.owlCarousel('destroy');
      });

      $element.on('click', '.owl-next, .owl-prev', function () {
        $(document).trigger('common:pixel:pageview');

        KINDERNETZ.Utils.updateLazyLoad();
      });

      //$element.on('drag.owl.carousel' + EVENT_KEY, function (event) {
      //  $element.removeClass('jerk');

      //  KINDERNETZ.Utils.updateLazyLoad();
      //});

      $element.on('dragged.owl.carousel' + EVENT_KEY, function (event) {
        $(document).trigger('common:pixel:pageview');
      });

      $element.on('changed.owl.carousel' + EVENT_KEY, function (event) {
        KINDERNETZ.Utils.updateLazyLoad();
      });

      //if ($element.visible(false) && $element.attr('class').indexOf('Items-1') === -1 && !$element.hasClass('jerked') && 'undefined' === typeof Cookies.get('KINDERNETZPSO')) {
      //  $element.addClass('jerk jerked');
      //}

      //$(window).scroll(function(event) {
      //  if ($element.visible(false) && $element.attr('class').indexOf('Items-1') === -1 && !$element.hasClass('jerked') && 'undefined' === typeof Cookies.get('KINDERNETZPSO')) {
      //    $element.addClass('jerk jerked');
      //  }
      //});
    }

    // private
    Teaserkarussell.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // public
    Teaserkarussell.prototype.dispose = function dispose() {
      $(this.element).off(EVENT_KEY);
      $(this.element).owlCarousel('destroy');
      this.element = null;
    };

    // static
    Teaserkarussell._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        if (!data) {
          data = new Teaserkarussell(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named ' + config + '');
          }
          data[config]();
        }
      });
    };

    return Teaserkarussell;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $teaserkarusell = $(this);
    Teaserkarussell._jQueryInterface.call($teaserkarusell);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $teaserkarusell = $(this);
      Teaserkarussell._jQueryInterface.call($teaserkarusell);
    })
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Teaserkarussell._jQueryInterface;
  $.fn[NAME].Constructor = Teaserkarussell;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Teaserkarussell._jQueryInterface;
  };

  return Teaserkarussell;

})(window.jQuery);
